import React, { useState } from 'react'
import { Button, TextField, Banner } from '../ui'

export function ReflectionForm({ initial = {}, ownerUserId = null, existingTitles = [], onSave, onCancel }) {
  const [title, setTitle] = useState(initial.title || '')
  const [periodStart, setPeriodStart] = useState(initial.periodStart || '')
  const [periodEnd, setPeriodEnd] = useState(initial.periodEnd || '')
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState(null)

  const duplicateWarning = title.trim() && existingTitles.includes(title.trim())

  async function handleSubmit(e) {
    e.preventDefault()
    setError(null)
    if (!title.trim()) { setError('Title is required.'); return }

    setSaving(true)
    try {
      const body = { title: title.trim() }
      if (periodStart) body.periodStart = periodStart
      if (periodEnd) body.periodEnd = periodEnd
      if (ownerUserId) body.ownerUserId = ownerUserId
      await onSave(body)
    } catch (err) {
      setError(err?.message || 'Something went wrong.')
      setSaving(false)
    }
  }

  return (
    <form onSubmit={handleSubmit} style={styles.form}>
      {error && <Banner tone="error">{error}</Banner>}

      <TextField
        label="Title"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        placeholder="Q3 2026"
        required
      />

      {duplicateWarning && (
        <p style={styles.warning}>
          There's already an open reflection titled "{title.trim()}". Continue anyway?
        </p>
      )}

      <div style={styles.periodRow}>
        <TextField
          label="Period start"
          type="date"
          value={periodStart}
          onChange={(e) => setPeriodStart(e.target.value)}
        />
        <TextField
          label="Period end"
          type="date"
          value={periodEnd}
          onChange={(e) => setPeriodEnd(e.target.value)}
        />
      </div>

      <div style={styles.actions}>
        <Button variant="secondary" onClick={onCancel} type="button">Cancel</Button>
        <Button type="submit" loading={saving} loadingLabel="Creating...">
          New reflection
        </Button>
      </div>
    </form>
  )
}

const styles = {
  form: { display: 'flex', flexDirection: 'column', gap: '16px' },
  periodRow: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' },
  actions: { display: 'flex', justifyContent: 'flex-end', gap: '8px' },
  warning: {
    fontSize: '12px',
    color: '#8a5a2a',
    background: '#e89a5d18',
    border: '1px solid #e89a5d30',
    borderRadius: '8px',
    padding: '10px 14px',
    margin: 0,
    lineHeight: 1.5,
  },
}
